import { render, staticRenderFns } from "./educationResultVod.vue?vue&type=template&id=35b2b7b0"
import script from "./educationResultVod.vue?vue&type=script&lang=js"
export * from "./educationResultVod.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('35b2b7b0')) {
      api.createRecord('35b2b7b0', component.options)
    } else {
      api.reload('35b2b7b0', component.options)
    }
    module.hot.accept("./educationResultVod.vue?vue&type=template&id=35b2b7b0", function () {
      api.rerender('35b2b7b0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sop/edu/result/educationResultVod.vue"
export default component.exports